export const EARTH_RADIUS_IN_KILOMETERS = 6371.0008; // GRS 80
export const MAX_SEARCH_DISTANCE = 265000;
export const DEFAULT_RADIUS_IN_KILOMETERS = 25;
